import {createInternationalizationPrefixer} from "../platform/i18n/i18n";

const t = createInternationalizationPrefixer("FanSelectionCriteriaControls");

export function MechanicalConfigPreviewImage(props: {
    orientantion: "horizontal" | "vertical",
    clutchOnInlet: boolean,
    clutchPresent: boolean,
    silent: boolean,
    sameSide: boolean
}) {

    let imgName: string | "no-preview-available";

    if (props.orientantion === "horizontal") {

        if (props.clutchOnInlet) {
            // Dawne WAS
            if (props.sameSide) {
                // Dawne WAS2
                imgName = props.clutchPresent ? "hsi2" : "hbsi2";
            } else {
                // Dawne WAS1
                imgName = props.clutchPresent ? "hsi1" : "hbsi1";
            }
        } else {
            // Dawne WBS
            if (props.sameSide) {
                // Dawne WBS2
                imgName = props.clutchPresent ? "hso2" : "hbso2";
            } else {
                // Dawne WBS1
                imgName = props.clutchPresent ? "hso1" : "hbso1";
            }
        }
    } else {
        if (props.clutchOnInlet) {
            // Dawne WCS
            if (props.sameSide) {
                // Dawne WCS2
                imgName = props.clutchPresent ? "vsi2" : "vbsi2";
            } else {
                // Dawne WCS1
                imgName = props.clutchPresent ? "vsi1" : "vbsi1";
            }
        } else {
            imgName = "no-preview-available";
        }
    }

    if (props.silent && imgName !== "no-preview-available") {
        imgName += "silent";
    }

    if (imgName !== "no-preview-available") {
        imgName += ".png";
    }

    return <>
        {imgName !== "no-preview-available" && <img className={"mh-250px"} src={"/img/position/" + imgName}/>}
        {imgName === "no-preview-available" && <div className={"text-center fs-5 text-gray-600"}>{t("Brak podglądu")}</div>}
    </>
}